/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Register from './components/Register';
import Login from './components/Login';
import UserList from './components/UserList';
import BottomBar from './components/BottomBar';
import TopBar from './components/TopBar';
import BlogAdmin from './components/BlogAdmin';
import BlogList from './components/BlogList';
import BlogView from './components/BlogView';
import NodeInfoDashboard from './components/MeshtasticNodes';
import ChannelMessageViewer from './components/MeshtasticMessages';
import MessageAdmin from './components/MeshtasticSendMessage';
import NotificationBox from './components/NotificationBox';
import { jwtDecode } from 'jwt-decode';

function App() {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    const storedMode = localStorage.getItem('darkMode');
    return storedMode === 'true' || false;
  });

  const [notification, setNotification] = useState(null);

  const showNotification = (message, type = 'info') => {
    setNotification({ message, type });
  };

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    if (token && storedUser) {
      const decodedToken = jwtDecode(token);
      if (decodedToken.exp * 1000 > Date.now()) {
        setUser(JSON.parse(storedUser));
        setIsAuthenticated(true);
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setIsAuthenticated(false);
    showNotification('Logged out successfully', 'success');
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <Router>
      <div className={`min-h-screen flex flex-col ${darkMode ? 'bg-gray-800 text-white' : 'bg-gray-100 text-black'}`}>
        
        {/* Top Notification */}
        {notification && (
          <NotificationBox
            message={notification.message}
            type={notification.type}
            onClose={() => setNotification(null)}
          />
        )}

        {/* Top Navigation Bar */}
        <TopBar
          handleLogout={handleLogout}
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
        />

        {/* Page Content */}
        <main className="flex-grow flex justify-center">
          <div className="w-full max-w-4xl p-4">
            <Routes>
              <Route
                path="/"
                element={
                  <h1 className="text-3xl font-bold">
                    Velkommen til Mouum.net
                  </h1>
                }
              />
              <Route
                path="/register"
                element={<Register darkMode={darkMode} showNotification={showNotification} />}
              />
              <Route
                path="/login"
                element={
                  <Login
                    setUser={setUser}
                    setIsAuthenticated={setIsAuthenticated}
                    darkMode={darkMode}
                    showNotification={showNotification}
                  />
                }
              />
              <Route
                path="/users"
                element={<UserList darkMode={darkMode} showNotification={showNotification} />}
              />
              <Route path="/admin/blog" element={<BlogAdmin darkMode={darkMode} />} />
              <Route path="/blog" element={<BlogList darkMode={darkMode} />} />
              <Route path="/blog/:slug" element={<BlogView darkMode={darkMode} />} />
              <Route path="/meshtastic/nodes" element={<NodeInfoDashboard darkMode={darkMode} />} />
              <Route path="/meshtastic/nodes/:fromId" element={<NodeInfoDashboard darkMode={darkMode} />} />
              <Route path="/meshtastic/messages/:channel" element={<ChannelMessageViewer darkMode={darkMode} />} />
              <Route path="/meshtastic/messages" element={<ChannelMessageViewer darkMode={darkMode} />} />
              <Route path="/meshtastic/send" element={<MessageAdmin darkMode={darkMode} showNotification={showNotification} />} />
            </Routes>
          </div>
        </main>

        {/* Bottom Navigation Bar */}
        <BottomBar
          user={user}
          handleLogout={handleLogout}
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
        />
      </div>
    </Router>
  );
}

export default App;
